const expiryKey = 'mdi-icons-expiry';

const loaders: Map<String, Promise<void>> = new Map();
const data: Object = ref({

});
const getLoader = (name: string, $locally: any) => (loaders.has(name)
    ? loaders.get(name)
    : loaders.set(name, new Promise<void>(async (resolve) => {
        const key = `mdi-${name}`;
        let icon = $locally.getItem(key);

        data.value[name] = null;

        if (!icon) {
            icon = await $fetch(`/api/mdi/${name}`);

            if (icon) {
                $locally.setItem(key, icon);
            }
        }

        data.value[name] = icon;

        resolve();
    })).get(name)) as any;

export const useIconRaw = (name: string) => new Promise<string>(async (resolve) => {
    const {
        $locally,
    }: any = useNuxtApp();

    await callOnce(async () => {
        const expiry: number = $locally.getItem(expiryKey);

        if (expiry) {
            if (Date.now() > expiry) {

                $locally.filterKeys('mdi-').forEach((key: string) => {
                    $locally.remove(key);
                });
            }
        } else {
            $locally.setItem(expiryKey, Date.now() + (3.154e+7 * 1000));
        }
    });

    await getLoader(name, $locally);

    resolve(data.value[name]);
});

export const useIcon = (name: string) => new Promise<string>(async (resolve) => {
    const {
        $locally,
    }: any = useNuxtApp();

    await callOnce(async () => {
        const expiry: number = $locally.getItem(expiryKey);

        if (expiry) {
            if (Date.now() > expiry) {

                $locally.filterKeys('mdi-').forEach((key: string) => {
                    $locally.remove(key);
                });
            }
        } else {
            $locally.setItem(expiryKey, Date.now() + (3.154e+7 * 1000));
        }
    });

    await getLoader(name, $locally);

    resolve(computed(() => data.value[name]));
});